export class RequestRoleTypes {
  /** Инженер ПТО */
  public static PTOEngineer = 7;

  /** Инженер АН */
  public static ASEngineer = 8;
}